export default "__VITE_ASSET__DMboE$St__"